"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessage = exports.ErrorDisplayWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorDisplayWrapper = _styledComponents.default.div.withConfig({
  displayName: "ErrorDisplaystyles__ErrorDisplayWrapper",
  componentId: "sc-1kgho46-0"
})(["margin-bottom:", ";min-height:2rem;"], function (props) {
  return props.theme.standardPadding;
});

exports.ErrorDisplayWrapper = ErrorDisplayWrapper;

var ErrorMessage = _styledComponents.default.div.withConfig({
  displayName: "ErrorDisplaystyles__ErrorMessage",
  componentId: "sc-1kgho46-1"
})(["color:", ";margin:0;"], function (props) {
  return props.theme.c_foreground_danger;
});

exports.ErrorMessage = ErrorMessage;